import request from "@/utils/request";

let CollectionApi = {
  /*获取数据*/
  getData(data, errorback) {
    return request._get("/shop/plus.collection/index", data, errorback);
  },
  /*保存数据*/
  saveData(data, errorback) {
    return request._post("/shop/plus.collection/index", data, errorback);
  },
  /*发送催收短信*/

  sendSms(data, errorback) {
    return request._post("/shop/collection.index/sendSms", data, errorback);
  },
  /*录入电话催收*/

  addPhoneLog(data, errorback) {
    return request._post("/shop/collection.index/addPhoneLog", data, errorback);
  },
  /*催收电话记录列表*/

  phoneLog(data, errorback) {
    return request._post("/shop/collection.index/phoneLog", data, errorback);
  },
  /*催收短信记录列表*/

  smsLog(data, errorback) {
    return request._post("/shop/collection.index/smsLog", data, errorback);
  },
  /*生成还款码*/

  repayMent(data, errorback) {
    return request._post("/shop/collection.index/repayMent", data, errorback);
  }
};
export default CollectionApi;



// WEBPACK FOOTER //
// ./src/api/collection.js